import { FacilityFieldsFragment, BffFacility } from '@/graphql/__generated/sdk';

import { BrandThemeConfig, TOfficeInfo } from '@shared-components/types';
import { officePathByBrand } from '@utils/officeURLByBrand';

export const replaceUrlContentVars = (
	href: string,
	officeInfo: FacilityFieldsFragment | null,
	officeLocationInfo: TOfficeInfo | null,
	config: BrandThemeConfig,
	typeName?: string
) => {
	if (href.includes('[facilityUrl]') || typeName === 'FacilityDetailsPage' || typeName === 'ServiceDetailsPage') {
		const address: FacilityFieldsFragment['address'] | BffFacility['address'] =
			officeInfo?.address || officeLocationInfo?.address;
		if (address) {
			const facilityUrl = officePathByBrand(config.themeId, {
				stateStrOptions: {
					stateAbbreviation: address?.stateCode || '',
					state: '',
					city: address?.city || '',
				},
				cityAddressOptions: {
					city: address?.city || undefined,
					address: address?.address1?.replaceAll('/', '-') || undefined,
					zip: address?.zipCode || undefined,
				},
			});

			const facilityBasePath = config.features.otherApps.facilityDetailsBasePath;
			// Keep href token replacement for legacy call sites that do not pass typeName.
			if (href.includes('[facilityUrl]')) {
				const regex = /\/?\[facilityUrl]\/?/;
				return href.replace(regex, `/${facilityBasePath}/${facilityUrl}/`);
			}

			if (typeName === 'FacilityDetailsPage') {
				return `/${facilityBasePath}/${facilityUrl}/`;
			}

			if (typeName === 'ServiceDetailsPage') {
				return `/${facilityBasePath}/${facilityUrl}${href}`;
			}
		}
		return href;
	}

	if (href.includes('[schedulingUrl]')) {
		if (officeInfo?.scheduling?.schedulingUrl) {
			return href.replace('[schedulingUrl]', officeInfo?.scheduling?.schedulingUrl);
		}
		return href.replace('[schedulingUrl]', `/${config.features.otherApps.facilityDetailsBasePath}`);
	}

	return href;
};
